import { render, staticRenderFns } from "./IranValidityReports.vue?vue&type=template&id=1a6ce055"
import script from "./IranValidityReports.vue?vue&type=script&lang=js"
export * from "./IranValidityReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports